//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { MODES, GROUP_INCLUSION_MODE_OPTIONS, ADDITIONAL_DEPARTURE_INCLUSION_MODE_OPTIONS } from './RequestWorkTypeReportInclusionMode.js'

export default {
  name: 'RequestWorksGroupInclusionModeEditor',
  components: {
    // Чтобы избежать рекурсивности
    RequestWorkTypeListElement: () => import('./RequestWorkTypeListElement.vue'),
    RequestWorkTypesList: () => import('./RequestWorkTypesList.vue')
  },
  props: {
    workTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    workPackages: {
      type: Array,
      default: function () {
        return []
      }
    },
    request: {
      type: Object,
      required: true
    },
    isAdditionalDeparture: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selectedMode: GROUP_INCLUSION_MODE_OPTIONS[0].children ? GROUP_INCLUSION_MODE_OPTIONS[0].children[0] : GROUP_INCLUSION_MODE_OPTIONS[0],

      modes: MODES,
      groupInclusionModeOptions: GROUP_INCLUSION_MODE_OPTIONS,
      additionalDepartureInclusionModeOptions: ADDITIONAL_DEPARTURE_INCLUSION_MODE_OPTIONS,

      workTypesLocal: JSON.parse(JSON.stringify(this.workTypes)),
      workPackagesLocal: JSON.parse(JSON.stringify(this.workPackages)),

      selectedWorkTypes: new Set(),

      showHints: false,

      applyToCurrentReport: false
    }
  },
  computed: {
    ...mapGetters({
      defaultWorkTypes: 'getWorkTypes'
    }),
    options: function () {
      return this.isAdditionalDeparture ? [...this.additionalDepartureInclusionModeOptions, ...this.groupInclusionModeOptions] : this.groupInclusionModeOptions
    },
    pauseMode: function () {
      return this.modes.find(mode => mode.key === 'stopped')
    },
    workTypesFlatList: function () {
      return this.workTypesLocal
        .concat(this.workPackagesLocal.flatMap(wP => {
          return wP.workTypes.map(wT => {
            return {
              ...wT,
              workPackages: [wP]
            }
          })
        }))
    },
    workTypesToChange: function () {
      return this.workTypesFlatList.filter(wT => {
        if (this.selectedMode) {
          return this.selectedMode.isApplicable(wT, this.request.hasNotReadyReport)
        }
        return false
      })
    },
    workTypesToChangeCaption: function () {
      return this.selectedMode && this.selectedMode.changedWorkTypesCaption || 'Будет изменен режим автоматического добавления для следующих работ:'
    },
    selectedWorkTypesObjects: function () {
      return this.workTypesLocal.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT)))
        .concat(this.workPackagesLocal.flatMap(wP => {
          return wP.workTypes.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT, wP)))
        }))
    },
    workTypesAffectedByApplyCurrentReport: function () {
      return this.selectedWorkTypesObjects.filter(wT => this.applyToCurrentReport
        ? this.selectedMode && this.selectedMode.parentValue === 'pause' ? wT.includedInCurrentReport === true && !wT.hasDoneReports : wT.includedInCurrentReport === false
        : true
      )
    },
    workTypesAffectedByApplyCurrentReportCaption: function () {
      return this.selectedMode && this.selectedMode.parentValue === 'pause' ? 'Будут удалены работы:' : 'Будут добавлены работы:'
    },
    isAllSelected: function () {
      const allWorkTypes = this.workTypesFlatList
      return allWorkTypes.length && allWorkTypes.every(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT, wT.workPackages && wT.workPackages[0]))) ||
        (allWorkTypes.length && allWorkTypes.some(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT, wT.workPackages && wT.workPackages[0]))) ? 0 : false)
    }
  },
  watch: {
    workPackages: {
      handler: function (value) {
        this.workPackagesLocal = JSON.parse(JSON.stringify(value))
      },
      deep: true
    },
    workTypes: {
      handler: function (value) {
        this.workTypesLocal = JSON.parse(JSON.stringify(value))
      },
      deep: true
    },
    selectedMode: {
      handler: function (value) {
        const selectedWorkTypes = new Set()
        this.workTypesToChange.forEach(wT => {
          selectedWorkTypes.add(this.getSelectedWorkTypeKey(wT, wT.workPackages && wT.workPackages[0]))
        })
        this.selectedWorkTypes = selectedWorkTypes
      },
      immediate: true
    }
  },
  methods: {
    onSelectOption: function (option) {
      if (option.children) {
        this.selectedMode = option.children[0]
      } else {
        this.selectedMode = option
      }
    },
    onSaveSelection: function () {
      this.selectedWorkTypesObjects.forEach(wT => {
        if (this.selectedMode && this.selectedMode.mode && this.selectedMode.isApplicable(wT, this.request.hasNotReadyReport)) {
          const defaultWorkType = this.defaultWorkTypes.find(workType => workType.id === wT.id)
          this.selectedMode.mode(wT, defaultWorkType).set(wT)
        }
        if (this.applyToCurrentReport) {
          this.$set(wT, 'includedInCurrentReport', !(this.selectedMode && this.selectedMode.mode && this.selectedMode.mode(wT).key === 'stopped'))
        }
        if (wT.workPackages && wT.workPackages.length > 0) {
          const workPackage = this.workPackagesLocal.find(wP => wP.id === wT.workPackages[0].id)
          const workTypeInPackageIndex = workPackage.workTypes.findIndex(wTInPackage => wTInPackage.id === wT.id)
          if (workTypeInPackageIndex !== -1) {
            delete wT.workPackages
            workPackage.workTypes.splice(workTypeInPackageIndex, 1, wT)
          }
        }
      })
      this.$emit('select', { workPackages: this.workPackagesLocal, workTypes: this.workTypesLocal })
    },
    getSelectedWorkTypeKey: function (workType, workPackage) {
      return `${workType.id}.${workPackage && workPackage.id}`
    },
    onInputCheckbox: function (data) {
      const newSelectedWorkTypes = new Set(this.selectedWorkTypes)
      if (newSelectedWorkTypes.has(this.getSelectedWorkTypeKey(data.workType, data.workPackage))) {
        newSelectedWorkTypes.delete(this.getSelectedWorkTypeKey(data.workType, data.workPackage))
      } else {
        newSelectedWorkTypes.add(this.getSelectedWorkTypeKey(data.workType, data.workPackage))
      }
      this.selectedWorkTypes = newSelectedWorkTypes
    },
    getSelectAllWorkPackageValue: function (data) {
      return data.workPackage.workTypes.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT, data.workPackage))).length === data.workPackage.workTypes.length ? true
        : !data.workPackage.workTypes.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT, data.workPackage))).length ? false
          : 0
    },
    getSelectAllWorkTypesValue: function (data) {
      return data.workTypes.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT))).length === data.workTypes.length ? true
        : !data.workTypes.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT))).length ? false
          : 0
    },
    onSelectAll: function (workTypes, workPackage) {
      const newSelectedWorkTypes = new Set(this.selectedWorkTypes)
      if (workTypes.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT, workPackage))).length !== workTypes.length) {
        workTypes.forEach(wT => {
          newSelectedWorkTypes.add(this.getSelectedWorkTypeKey(wT, workPackage))
        })
      } else {
        workTypes.forEach(wT => {
          newSelectedWorkTypes.delete(this.getSelectedWorkTypeKey(wT, workPackage))
        })
      }
      this.selectedWorkTypes = newSelectedWorkTypes
    },
    onInputAllSelected: function () {
      const allWorkTypes = [
        ...this.workTypesLocal,
        ...this.workPackagesLocal.flatMap(wP => wP.workTypes.map(wT => {
          return {
            ...wT,
            workPackages: [wP]
          }
        }))
      ]
      const newSelectedWorkTypes = new Set(this.selectedWorkTypes)
      if (allWorkTypes.filter(wT => this.selectedWorkTypes.has(this.getSelectedWorkTypeKey(wT, wT.workPackages && wT.workPackages[0]))).length !== allWorkTypes.length) {
        allWorkTypes.forEach(wT => {
          newSelectedWorkTypes.add(this.getSelectedWorkTypeKey(wT, wT.workPackages && wT.workPackages[0]))
        })
      } else {
        allWorkTypes.forEach(wT => {
          newSelectedWorkTypes.delete(this.getSelectedWorkTypeKey(wT, wT.workPackages && wT.workPackages[0]))
        })
      }
      this.selectedWorkTypes = newSelectedWorkTypes
    }
  }
}

